import React from 'react';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import './OpenSubmissionsCapsule.scss';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import OpenSubmissionsCapsuleSettings, {
    OpenSubmissionsCapsuleSettingsText,
} from './OpenSubmissionsCapsuleSettings';
import { useTileInNewportSingleWidgetMode } from 'widgets/tiles/components/toolbar/hooks';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import InfoBox from 'utils/components/InfoBox/InfoBox';
import { OpenSubmissionsCapsuleContent } from 'widgets/openSubmissions/capsule/OpenSubmissionsCapsuleContent';
import OpenSubmissionsCapsuleHelp from './OpenSubmissionsCapsuleHelp';
import { useWarningForOrderDependentCapsules } from '../../tiles/components/tile/hooks';

export function OpenSubmissionsCapsule() {
    useWidgetStream();

    const isNewportSingleWidget = useTileInNewportSingleWidgetMode();

    const warning = useWarningForOrderDependentCapsules();

    return (
        <WidgetTile className="OpenSubmissionsCapsule ">
            <TileToolbar
                settingsBody={<OpenSubmissionsCapsuleSettings />}
                settingsHeader={OpenSubmissionsCapsuleSettingsText}
                hideSettingsButton={!isNewportSingleWidget}
                title={'Open Submissions'}
                preceedingItems={<OpenSubmissionsCapsuleHelp />}
                wideTitle={true}
            />
            <div className="capsule-body">
                {warning && <InfoBox info={warning} />}
                {!warning && <OpenSubmissionsCapsuleContent />}
            </div>
        </WidgetTile>
    );
}
